<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path d="m5.999 0 .316.008A6 6 0 1 1 6 0h-.001zM6 .667a5.333 5.333 0 1 0 0 10.666l.28-.007a5.333 5.333 0 0 0 2.14-.573l.247-.134A5.334 5.334 0 0 0 6 .667zm.65 3.985-.014 4.663H5.351V4.652h1.298zm.007-2.004v1.315H5.343V2.648h1.314z" fill="#A9B7D1" fill-rule="evenodd" />
  </svg>
</template>
